// extracted by mini-css-extract-plugin
export default {"action":"action--v5d0jMUdaF","icon":"icon--BWcTDKMUSg"};